import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const ResizeWithPrecisionImagePreview = dynamic<{ image?: string }>(
    () => import("components/features/JpgResizer/JpgResizerFeatures").then((mod) => mod),
    {
        ssr: false,
    },
);

const JpegResizerFeaturesSecondImagePreview = dynamic<{ image?: string }>(
    () => import("components/features/JpgResizer/JpgResizerFeature2").then((mod) => mod),
    {
        ssr: false,
    },
);

export const ResizeWithPrecisionSection = ({ image }: { image?: string }) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 gap-2 hidden md:block">
                    <ResizeWithPrecisionImagePreview image={image} />
                </div>
                <div className="flex-1 dark:text-white text-center md:text-left">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="JPG-Resize-with-Precision-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="JPG-Resize-with-Precision-subtitle" />
                    </p>
                </div>
                <div className="flex-1 gap-2  md:hidden">
                    <ResizeWithPrecisionImagePreview image={image} />
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Control-Resized-JPG-Size-and-Format-with-Ease-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="Control-Resized-JPG-Size-and-Format-with-Ease-subtitle" />
                    </p>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <JpegResizerFeaturesSecondImagePreview image={image} />
                </div>
            </div>
            <div className="flex-1 gap-2  md:hidden">
                <JpegResizerFeaturesSecondImagePreview image={image} />{" "}
            </div>
        </>
    );
};
